import { Dayjs } from 'dayjs'

import { DATE_TEMPLATES } from './dateTemplates'
import { day } from './day'
import { format } from './format'

/**
 * Returns the date in the format 'YYYY-MM-DD'.
 *
 * @param {Dayjs | string} date - The date to be formatted.
 * @return {string} The formatted date.
 */

const stringCache = new Map<string, string>()
const dayjsCache = new WeakMap<Dayjs, string>()
const timestampCache = new Map<number, string>()

export function getOnlyDate(date: Dayjs | string): string {
    if (typeof date === 'string') {
        const cached = stringCache.get(date)
        if (cached !== undefined) {
            return cached
        }

        const dayjsDate = day(date)
        const formattedDate = format(dayjsDate, DATE_TEMPLATES.iso)
        stringCache.set(date, formattedDate)
        return formattedDate
    }

    // It is a Dayjs object
    const cachedFromWeakMap = dayjsCache.get(date)
    if (cachedFromWeakMap !== undefined) {
        return cachedFromWeakMap
    }

    const timestamp = date.valueOf()
    const cachedFromTimestamp = timestampCache.get(timestamp)
    if (cachedFromTimestamp !== undefined) {
        dayjsCache.set(date, cachedFromTimestamp)
        return cachedFromTimestamp
    }

    const formattedDate = format(date, DATE_TEMPLATES.iso)
    timestampCache.set(timestamp, formattedDate)
    dayjsCache.set(date, formattedDate)
    return formattedDate
}
